// LandingPageSlider.jsx
import { useState, useEffect } from 'react';
import './landingPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft,faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const slides = [
    {
        image: '/images/cover102.pnc.png',
        title: 'Heal & Energize Through Personalised Yoga',
        title2: 'Explore general wellness classes for women and therapeutic yoga sessions tailored to your needs- designed with care, backed by science ',
        buttonText1: 'JOIN A CLASS',
        buttonText2: 'BOOK A FREE CONSULTATION'
    }
    // {
    //     image: 'https://images.wallpaperscraft.com/image/single/yoga_silhouette_lake_121019_1600x900.jpg',
    //     title: 'Explore the Unseen Beauty',
    //     buttonText: 'LEARN MORE'
    // },
    // {
    //     image: 'https://images.wallpaperscraft.com/image/single/meditation_yoga_silhouette_138891_1600x900.jpg',
    //     title: 'Adventure Awaits You',
    //     buttonText: 'JOIN NOW'
    // }
];

const LandingPageSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    return (
        <div className="slider-container">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`slide ${index === currentSlide ? 'active' : ''}`}
                >
                    <img src={slide.image} alt={`Slide ${index + 1}`} />
                    <div className="text-overlay">
                        <h2>{slide.title}</h2>
                        <h3>{slide.title2}</h3>
                        
                        <div className="button-group">
                            <a href="#target-section" className="hero-btn btn-primary">{slide.buttonText1}</a>
    <Link to="/contact" className="hero-btn btn-secondary">{slide.buttonText2}</Link>
                            
                            
                        </div>
                    </div>
                </div>
            ))}

            <button className="prev" onClick={() => goToSlide((currentSlide - 1 + slides.length) % slides.length)}><FontAwesomeIcon icon={faChevronLeft} /></button>
            <button className="next" onClick={() => goToSlide((currentSlide + 1) % slides.length)}><FontAwesomeIcon icon={faChevronRight} /></button>

            <div className="dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default LandingPageSlider;